import React, { useState, useEffect, useRef } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { FileCheck, Award, Globe, Zap } from 'lucide-react';

const stats = [
  { icon: FileCheck, value: 10000, suffix: '+', label: 'Brand Names Registered' },
  { icon: Award, value: 99, suffix: '%', label: 'Approval Rate' },
  { icon: Globe, value: 50, suffix: '', label: 'States Covered' },
  { icon: Zap, value: 48, suffix: 'h', label: 'Avg. Filing Speed' },
];

const Counter = ({ target, suffix }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !started.current) {
        started.current = true;
        const duration = 2000;
        const step = Math.max(1, Math.floor(target / (duration / 16)));
        let current = 0;
        const timer = setInterval(() => {
          current += step;
          if (current >= target) { setCount(target); clearInterval(timer); } else setCount(current);
        }, 16);
      }
    }, { threshold: 0.3 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target]);
  return <span ref={ref}>{target >= 10000 ? `${Math.floor(count / 1000)}K` : count.toLocaleString()}{suffix}</span>;
};

const StatsSection = () => {
  const section = useScrollAnimation({ threshold: 0.15 });
  return (
    <section data-testid="stats-section" ref={section.ref} className="py-24 md:py-32 bg-[#093336]/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className={`grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 scroll-fade-up ${section.isVisible ? 'scroll-visible' : ''}`}>
          {stats.map((stat, i) => {
            const Icon = stat.icon;
            return (
              <div key={i} data-testid={`stat-card-${i}`} className="bg-[#093336]/60 backdrop-blur-sm border border-white/5 rounded-2xl p-8 text-center group transition-all duration-300 hover:border-[#A5BF23]/30 hover:bg-[#093336]/80">
                <div className="w-12 h-12 rounded-xl bg-[#A5BF23]/10 flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-6 h-6 text-[#A5BF23]" strokeWidth={1.5} />
                </div>
                <div className="text-4xl md:text-5xl font-bold text-[#A5BF23] mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  <Counter target={stat.value} suffix={stat.suffix} />
                </div>
                <div className="text-sm text-[#A0B2B2]">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
